<template>
  <label :for="name" class="block">
    <span v-if="label" class="text-gray-800 font-semibold text-base"
    >{{ label }}
      <span v-if="required" class="text-red-800 font-bold"
      >* <span class="sr-only">Required Field</span></span
      ></span
    >
    <span
        v-if="description"
        class="text-gray-800 text-sm font-light block mb-1"
    >{{ description }}</span
    >
    <input
        :id="name"
        :class="inputClasses"
        :type="type"
        :name="name"
        :required="required"
        :disabled="disabled"
        :value="internalModel"
        @input="inputChange"
        @blur="$emit('blur')"
        :maxlength="calcMaxLength()"
    />
    <div v-if="charCount" class="flex gap-2 mt-1">
      <span class="text-gray-800 text-sm min-w-fit">{{ currentCharCount() }} / {{ calcMaxLength() }}</span>
    </div>
    <span v-if="vuelidation.$dirty && vuelidation.$invalid" class="block">
      <span class="text-red-900 text-sm italic" v-for="error in vuelidation.$errors">{{ error.$message }}</span>
    </span>
  </label>
</template>

<script>
import { version as VueVersion } from "vue";

const VueMajorVersion = VueVersion.charAt(0) * 1;

export default {
  props: {
    charCount: {
      type: Number,
    },
    description: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    maxlength: {
      type: Number,
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    required: Boolean,
    type: {
      type: [String],
      validator(value) {
        return ['text', 'tel', 'email', 'number'].includes(value);
      },
      default: "text",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    vuelidation: {
      type: [Object, Boolean],
      default: false,
    }
  },
  data: function () {
    return {
      modelData: this.modelValue,
    };
  },
  mounted() {
  },
  computed: {
    inputClasses() {
      if (!this.disabled) {
        return "text-base block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-200 focus:ring-opacity-20";
      } else {
        return "p-0 text-base block w-full border-none bg-gray-100 text-gray-800 mb-2"
      }
    },
    internalModel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        if (VueMajorVersion === 2) {
          this.$emit('input', value.target.value);
        } else if (VueMajorVersion === 3) {
          this.$emit("update:modelValue", value);
        }
      },
    },
  },
  emits: ["update:modelValue"],
  methods: {
    inputChange(e) {
      this.internalModel = e.target.value;
    },
    currentCharCount() {
      return this.internalModel.length;
    },
    calcMaxLength() {
      if (this.charCount) {
        return this.charCount;
      } else if (this.maxlength) {
        return this.maxlength;
      } else {
        return undefined;
      }
    }
  }
}
</script>
